import React from 'react';
import { Empty } from 'antd';
import { SharedEMSSummaryReport } from './templates/SharedEMSSummaryReport';
import { resolveEMSSummaryConfig } from './reportConfigResolver';

export function EMSSummaryReport(props) {
   const config = resolveEMSSummaryConfig(props.template);

   if (!config) {
      return <Empty description='Report not yet available.' image="../images/brainee_mascot.png" />;
   }

   return <SharedEMSSummaryReport {...props} config={config} />;
}
